import React, { memo } from "react"
import Box from "@material-ui/core/Box"
import { makeStyles } from "@material-ui/core/styles"
import Button from "@material-ui/core/Button"
import ViewManagerTable from "@/components/project-dashboard/account-holder-main/view-manager/ViewManagerTable"
import { useNavigate } from "react-router-dom"
import { urlPath } from "@/utils"

const useStyles = makeStyles((theme) => ({
    wrapper: {
        padding: theme.spacing(3),
    },
    assignManagerPageButton: {
        marginRight: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
}))

const ViewManager = memo((props) => {
    const { userCompanyId, userId } = props
    const classes = useStyles()
    const navigate = useNavigate()

    return (
        <Box className={classes.wrapper}>
            <Box mb={3}>
                <Button
                    variant="contained"
                    color="primary"
                    className={classes.assignManagerPageButton}
                    onClick={() => navigate(urlPath("account-holder-main", userId))}
                >
                    Home Page
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    className={classes.assignManagerPageButton}
                    onClick={() => navigate(urlPath("dashboard", userId))}
                >
                    Project Dashboard
                </Button>
            </Box>
            <Box mt={3}>
                <ViewManagerTable userCompanyId={userCompanyId} />
            </Box>
        </Box>
    )
})

export default ViewManager
